export const endpoint = {
  booking: '/registry/update/tracking',
  index: '/reports/registries',
  estimate: '/registry/update/estimation',
  update: '/registry/update'
};
export const tableName = 'dashboardAdvancedSearch';



// WEBPACK FOOTER //
// ./src/containers/DashboardAdvancedSearch/constants.js